import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Repo } from '@repos/repo.service';
import { BusinessUser, BusinessUserRole } from '@models/businesses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { CollectionPaths } from '@models/collections';
import { UserProfileState } from '@state/user-profile';

@Injectable({
	providedIn: 'root',
})
export class BusinessUsersService extends Repo<BusinessUser, unknown> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;

	GetCollectionPath(businessId?: string): string {
		return CollectionPaths.business_users(businessId ?? this.businessId);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	SetUserRole(
		userId: string,
		role: BusinessUserRole,
		businessId?: string,
	): Promise<void> {
		return this.Update(userId, { role }, businessId);
	}

	SetUserAdmin(userId: string, admin: boolean): Promise<void> {
		return this.Update(userId, { admin });
	}

	SetRestricted(userId: string, restricted: boolean): Promise<void> {
		return this.Update(userId, { restricted });
	}
}
